var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWunderGraph = function SvgWunderGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 175 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#WunderGraph_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.85 1.412c.903 1.4 1.792 2.81 2.665 4.23a.262.262 0 0 0-.116.174 13.487 13.487 0 0 0-3.709-.58c.066-.23.008-.463-.173-.695a32.722 32.722 0 0 0-2.144-3.129 13.77 13.77 0 0 1 3.476 0Z",
    opacity: 0.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.373 1.412c.774 1 1.49 2.046 2.143 3.13.182.231.24.463.174.694a21.947 21.947 0 0 0-3.592.232 733.79 733.79 0 0 0-1.97-3.245c.042-.079.08-.156.116-.231a15.967 15.967 0 0 1 3.129-.58Z",
    opacity: 0.983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 1.412c1.298.068 2.583.302 3.824.695l6.373 10.199c-1.379-.24-2.325-1.012-2.839-2.318a7.113 7.113 0 0 1-.348-2.086A12.441 12.441 0 0 0 24.4 5.816a.262.262 0 0 1 .116-.174c-.873-1.42-1.762-2.83-2.666-4.23Z",
    opacity: 0.974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.244 1.991a5.181 5.181 0 0 1-.116.232c.66 1.08 1.316 2.162 1.97 3.245-.881.293-1.77.564-2.666.811a35.384 35.384 0 0 1-2.086-3.245 12.93 12.93 0 0 1 2.898-1.043Z",
    opacity: 0.984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.674 2.107a22.826 22.826 0 0 1 5.736 2.666c2.393-.677 4.13.095 5.215 2.318.601 2.253-.114 3.934-2.144 5.04a4.378 4.378 0 0 1-2.434.175L25.674 2.107Z",
    opacity: 0.983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.347 3.035a35.383 35.383 0 0 0 2.085 3.245l-2.317 1.158a117.459 117.459 0 0 1-2.086-3.07.262.262 0 0 0 .116-.174 9.963 9.963 0 0 1 2.202-1.16Z",
    opacity: 0.978
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.145 4.194a.261.261 0 0 1-.116.173c.683 1.042 1.379 2.066 2.086 3.071-.608.453-1.207.916-1.797 1.391a5.458 5.458 0 0 0-3.07-2.491 15.475 15.475 0 0 1 2.897-2.144Z",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.548 23.083a.622.622 0 0 1-.405-.347A1451.087 1451.087 0 0 0 4.582 7.67c2.978-.477 4.677.797 5.099 3.824-.096.767-.27 1.5-.521 2.202a627.18 627.18 0 0 1 5.388 9.387Z",
    opacity: 0.965
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.582 7.67a1451.302 1451.302 0 0 1 9.56 15.066.622.622 0 0 0 .406.347 8.37 8.37 0 0 1 .927 1.623 39.908 39.908 0 0 0 2.202 3.476 13.66 13.66 0 0 1-1.159 2.086A3116.31 3116.31 0 0 0 2.96 8.598a2.871 2.871 0 0 1 1.623-.928Z",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96 8.597c4.549 7.205 9.068 14.43 13.558 21.671-.088.217-.204.41-.347.58-.228-.01-.402-.164-.522-.464L2.786 9.988a.734.734 0 0 0-.522-.464c.099-.408.33-.717.695-.927Z",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.161 24.01a.33.33 0 0 1-.29-.116c-1.253-1.97-2.509-3.94-3.766-5.91a7.264 7.264 0 0 1 .696-2.897 5.337 5.337 0 0 0 3.36 1.622 44.918 44.918 0 0 0-.463 3.998c.054 1.113.209 2.219.463 3.303Z",
    opacity: 0.981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.264 9.524c.246.062.42.216.522.464l12.863 20.396c.12.3.294.455.522.464-.142.4-.38.758-.696 1.043-3.172-5.433-6.32-10.88-9.444-16.34-3.162-.341-4.553-2.08-4.172-5.216.077-.31.212-.58.405-.81Z",
    opacity: 0.932
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.326 23.663c.673 1.035 1.35 2.078 2.028 3.129.056.11.075.225.058.347l-1.39 2.55a.331.331 0 0 1-.29-.116 728.783 728.783 0 0 0-6.78-10.662 8.396 8.396 0 0 1 1.159-1.97 363.934 363.934 0 0 1 4.404 7.533c.058.118.135.138.231.058.153-.327.346-.617.58-.87Z",
    opacity: 0.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.105 17.984c1.257 1.97 2.513 3.94 3.767 5.91a.33.33 0 0 0 .29.116 14.652 14.652 0 0 0 3.186 6.606 73.43 73.43 0 0 0 2.492 2.434c-.05-.008-.09.011-.116.058a476.525 476.525 0 0 0 3.824 6.084c-5.613-1.808-9.65-5.4-12.11-10.778-1.432-3.368-1.876-6.844-1.333-10.43Z",
    opacity: 0.983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.371 23.663a16.751 16.751 0 0 0-2.781-.116c.615-2.604 2.237-4.169 4.867-4.694a11.988 11.988 0 0 1 4.404.348c1.597.684 2.486 1.862 2.665 3.535a7.32 7.32 0 0 1-2.665.347c-.841-1.704-2.193-2.303-4.056-1.796-1.18.427-1.992 1.22-2.434 2.376Z",
    opacity: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.952 18.911c2.29 3.534 4.55 7.088 6.78 10.662a.331.331 0 0 0 .29.116 32.171 32.171 0 0 1-1.391 2.202 363.934 363.934 0 0 1-4.404-7.533c-.058-.118-.136-.138-.232-.058-.13.204-.247.417-.348.637a.622.622 0 0 1-.405-.347 87.751 87.751 0 0 0-1.912-3.013 45.583 45.583 0 0 1 1.622-2.666Z",
    opacity: 0.978
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.034 18.911c.217.077.449.154.696.232a77.677 77.677 0 0 1 2.086 3.36 6.623 6.623 0 0 0-1.739.117c-.278.52-.587 1.023-.927 1.506a.623.623 0 0 1-.405-.348 27.99 27.99 0 0 0-1.913-2.897c.362-.652.748-1.29 1.16-1.912a4.743 4.743 0 0 1 1.042-.058Z",
    opacity: 0.982
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.034 18.911h3.94c.637 1.04 1.274 2.083 1.913 3.13.205.242.456.397.753.463h-3.824a77.643 77.643 0 0 0-2.086-3.361c-.233-.073-.465-.15-.696-.232Z",
    opacity: 0.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.974 18.911h3.361a147.267 147.267 0 0 0 3.013 4.752 12.742 12.742 0 0 1-1.043 3.824 93.403 93.403 0 0 0-2.26-3.709.734.734 0 0 0-.52-.463 1.79 1.79 0 0 1 .115-.811 1.348 1.348 0 0 1-.753-.464 3843.74 3843.74 0 0 0-1.913-3.129Z",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.335 18.911a22.39 22.39 0 0 1 3.187.116c.102 1.547.044 3.1-.174 4.636a147.153 147.153 0 0 1-3.013-4.752Z",
    opacity: 0.964
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.829 23.663c-.007.063-.045.101-.116.115a4.296 4.296 0 0 0-1.332-.231 4.237 4.237 0 0 0-1.333.231v-4.867h2.665c-.038 1.604 0 3.188.116 4.752Z",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65 23.547a16.12 16.12 0 0 0-2.666.116 71.085 71.085 0 0 1-1.159-4.752h2.897c.294 1.548.603 3.093.927 4.636Z",
    opacity: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.066 22.156H49.2c.216-1.056.486-2.1.811-3.129a11.963 11.963 0 0 1 3.303 0c.27 1.039.52 2.082.753 3.13Z",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.281 23.547H56.5c.384-1.537.732-3.083 1.043-4.636h2.781a100.335 100.335 0 0 1-1.043 4.636Z",
    opacity: 0.971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.889 23.547h-2.666V18.91h2.666v4.636Z",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.832 20.881a27.991 27.991 0 0 1 1.913 2.898.622.622 0 0 0 .405.347 28.911 28.911 0 0 1-1.738 3.013.572.572 0 0 0-.058-.347c-.675-1.044-1.35-2.087-2.028-3.13.44-.958.944-1.887 1.506-2.78Z",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.199 22.156h4.867c.152.452.268.916.348 1.39h-2.55a6.82 6.82 0 0 0-.29-.81 5.776 5.776 0 0 1-.29.81h-2.433c.046-.493.162-.957.348-1.39Z",
    opacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.33 21.577a87.6 87.6 0 0 1 1.912 3.013.622.622 0 0 0 .405.347 3458.21 3458.21 0 0 1-1.97 3.245 39.895 39.895 0 0 1-2.202-3.476 62.1 62.1 0 0 0 1.855-3.13Z",
    opacity: 0.972
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.044 23.547h-6.026c.823-.816 1.828-1.202 3.013-1.159 1.169.003 2.173.39 3.013 1.159Z",
    opacity: 0.907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.678 23.547h-6.838a2.87 2.87 0 0 1 1.275-.87 8.145 8.145 0 0 1 4.636.116c.398.148.707.399.927.754Z",
    opacity: 0.916
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.16 23.547h-5.215c.683-.776 1.552-1.162 2.608-1.159.619.016 1.23.153 1.796.406.323.188.6.445.811.753Z",
    opacity: 0.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.524 23.315c.246.061.42.216.522.463a93.328 93.328 0 0 1 2.26 3.709 10.042 10.042 0 0 1-1.391 2.897 29.678 29.678 0 0 1-2.318-3.824 51.76 51.76 0 0 0 .927-3.245ZM90.223 23.547h2.55v1.506h-3.245c-.998-.797-1.964-.759-2.897.116a18.169 18.169 0 0 0-2.897-.116c.765-1.929 2.194-2.798 4.288-2.607a3.551 3.551 0 0 1 2.143 1.217c.047-.027.066-.065.058-.116Z",
    opacity: 0.981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.437 25.053h-3.361V22.62h2.434c-.02.388 0 .774.057 1.159 1.024-1.517 2.318-1.788 3.883-.812l-.811 2.086-.174.116c-.659-.408-1.335-.447-2.028-.116Z",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65 23.547c.16.49.276.995.347 1.506h-2.781l-.232-1.39c.884-.112 1.775-.151 2.665-.116Z",
    opacity: 0.961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.851 23.547h2.434a7.111 7.111 0 0 1-.348 1.506h-2.55c.104-.53.258-1.032.464-1.506Z",
    opacity: 0.965
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.864 23.547h2.55c.17.488.287.993.347 1.506h-2.549c-.134-.497-.25-1-.348-1.506Z",
    opacity: 0.964
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 23.547h2.781c-.117.55-.272 1.093-.463 1.622a14.1 14.1 0 0 0-2.55-.116 20.66 20.66 0 0 1 .232-1.506Z",
    opacity: 0.969
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.917 22.736c-.115.75-.154 1.523-.116 2.317h-2.55V22.62c.91-.038 1.799 0 2.666.116Z",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.059 25.053a8.183 8.183 0 0 1-2.666-.232V22.62h2.666v2.433Z",
    opacity: 0.964
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 24.822a8.48 8.48 0 0 1-2.781.231c-.885-.763-1.774-.763-2.666 0h-3.245V22.62h2.434c-.02.388 0 .774.058 1.159 1.294-1.31 2.82-1.677 4.578-1.101.975.388 1.516 1.103 1.622 2.143Z",
    opacity: 0.979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.018 23.547h6.026c.45.321.76.746.927 1.275-.359.153-.765.23-1.217.231a11.177 11.177 0 0 1-1.448-.116c-.881-.644-1.731-.605-2.55.116h-2.781a3.258 3.258 0 0 1 1.043-1.506Z",
    opacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.765 25.17c-.52-.078-1.06-.117-1.622-.117a6.944 6.944 0 0 0-1.738.232V22.62h2.549c-.019.348.001.698.058 1.043 1.03-1.414 2.286-1.645 3.767-.696a23.763 23.763 0 0 1-.812 2.144 8.315 8.315 0 0 0-1.274-.29 1.24 1.24 0 0 0-.928.348Z",
    opacity: 0.959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.59 23.547c.948-.038 1.875 0 2.781.116a8.399 8.399 0 0 1-.232 1.39 17.526 17.526 0 0 1-2.781-.116 4.39 4.39 0 0 1 .232-1.39Z",
    opacity: 0.971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.84 23.547h6.838c.386.415.578.918.579 1.506h-2.665c-.37-.427-.853-.62-1.449-.579-.834-.076-1.394.271-1.68 1.043l-.348.116a29.28 29.28 0 0 0-2.086-.348c.056-.69.326-1.268.811-1.738Z",
    opacity: 0.972
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.614 24.938c-.944.114-1.91.153-2.897.115a2.793 2.793 0 0 0-1.391-.58 3.834 3.834 0 0 0-1.39.58h-3.245a2.962 2.962 0 0 0-.116-1.159V22.62h2.55c-.02.388 0 .774.058 1.159 1.545-1.59 3.264-1.803 5.157-.638a3.289 3.289 0 0 1 1.274 1.797Z",
    opacity: 0.979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.829 23.663c0-.078.039-.116.116-.116h5.215c.395.413.589.915.58 1.506-.91-.037-1.799.001-2.666.116-.917-.887-1.882-.925-2.897-.116a11.13 11.13 0 0 1-3.129-.231v-1.043a4.234 4.234 0 0 1 1.333-.232c.466.009.911.086 1.332.232.071-.015.109-.053.116-.116Z",
    opacity: 0.981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.575 23.895c.114.362.152.748.116 1.158h3.245a4.325 4.325 0 0 0-.696 1.623 8.18 8.18 0 0 1-2.665-.232v-2.55Z",
    opacity: 0.909
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.393 24.822c.857.221 1.745.299 2.666.231v1.391a4.23 4.23 0 0 1-1.333.232 4.23 4.23 0 0 1-1.333-.232v-1.622Z",
    opacity: 0.956
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.216 25.053h2.781c.146.534.262 1.076.348 1.623a16.13 16.13 0 0 0-2.666.116 28.74 28.74 0 0 0-.463-1.739Z",
    opacity: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.388 25.053h2.55c-.118.55-.273 1.093-.464 1.623a12.853 12.853 0 0 1-2.434-.116c.06-.514.177-1.019.348-1.507Z",
    opacity: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.971 24.822c.307.612.5 1.269.58 1.97-2.098-.076-4.184-.154-6.258-.232h3.592a2.115 2.115 0 0 0-.579-1.623c.479.07.963.11 1.448.116a3.101 3.101 0 0 0 1.217-.232Z",
    opacity: 0.858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.212 25.053h2.55c.173.496.328.999.463 1.507-.845.112-1.698.15-2.55.116l-.463-1.623Z",
    opacity: 0.971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.268 25.053c.871-.037 1.721.001 2.55.116a7.118 7.118 0 0 1-.348 1.507h-2.55a6.21 6.21 0 0 1 .348-1.623Z",
    opacity: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.917 22.736v4.403a.535.535 0 0 1-.116-.463h-2.55v-1.623h2.55c-.038-.794 0-1.567.116-2.317Z",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.608 25.053h3.245a2.6 2.6 0 0 0-.58 1.623h-2.665v-1.623Z",
    opacity: 0.982
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3 24.822c.115.595.153 1.213.116 1.854a8.18 8.18 0 0 1-2.665-.232 4.447 4.447 0 0 0-.232-1.39 8.48 8.48 0 0 0 2.781-.232Z",
    opacity: 0.972
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.734 25.053c.987-.038 1.952.001 2.897.116-.306.454-.5.956-.58 1.507h-2.665a4.15 4.15 0 0 1 .348-1.623Z",
    opacity: 0.969
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.773 23.547h.116v3.592h-.116v-.463c-.89.035-1.782-.004-2.665-.116a3.585 3.585 0 0 0-.58-1.507h3.245v-1.506Z",
    opacity: 0.985
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.975 25.053h2.781c-.315.405-.47.869-.463 1.39a16.86 16.86 0 0 1-2.782.348 4.433 4.433 0 0 1 .464-1.738Z",
    opacity: 0.966
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.765 25.17a3.432 3.432 0 0 0-.579 1.621 5.703 5.703 0 0 0-2.781.116v-1.622a6.944 6.944 0 0 1 1.738-.232c.562 0 1.102.039 1.622.116Z",
    opacity: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.358 24.937c.923.113 1.853.151 2.781.116.049.579.087 1.158.116 1.738l-2.897-.231v-1.623Z",
    opacity: 0.979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.874 26.444a38.595 38.595 0 0 1-5.91.232v-1.507h5.91v1.275Zm2.202-1.39h3.361a3.296 3.296 0 0 0-.58 1.853l-2.781-.463v-1.39Z",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.592 25.053h2.665v1.623c-1.643.038-3.265 0-4.867-.116a15.404 15.404 0 0 0 2.202-.58c.11-.304.11-.613 0-.927Z",
    opacity: 0.969
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.614 24.937c.278.534.434 1.113.464 1.739a16.132 16.132 0 0 0-2.666.116 4.038 4.038 0 0 0-.695-1.739c.987.038 1.953 0 2.897-.116Z",
    opacity: 0.974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.048 24.822c1.012.223 2.055.3 3.129.231a4.266 4.266 0 0 0-.464 1.623h-2.665v-1.854Z",
    opacity: 0.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.74 25.053c.113.48.153.982.115 1.507-.878.112-1.767.15-2.665.116a8.93 8.93 0 0 0-.116-1.507 15.408 15.408 0 0 1 2.666-.116Z",
    opacity: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.293 26.444v.116c2.074.079 4.16.156 6.258.232v.811a178.663 178.663 0 0 0-9.04-.116v-.695a16.86 16.86 0 0 0 2.782-.348Z",
    opacity: 0.987
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.874 26.444v1.39a8.88 8.88 0 0 1-2.781.233.8.8 0 0 1-.116.579v-1.159h-3.013v-.811a38.595 38.595 0 0 0 5.91-.232Z",
    opacity: 0.923
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.39 26.56c1.602.115 3.224.154 4.867.116v1.39c-.86-.034-1.709.005-2.549.116a.99.99 0 0 0-.058-.463 3.629 3.629 0 0 1-1.449.347 15.915 15.915 0 0 1-3.824-.231 3.456 3.456 0 0 1 1.043-.754c.641-.227 1.3-.402 1.97-.521Z",
    opacity: 0.981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.186 26.792a8.38 8.38 0 0 1-.116 1.274h-2.549c.027.15-.012.266-.116.348v-1.506a5.7 5.7 0 0 1 2.781-.116Z",
    opacity: 0.933
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.225 26.56c.078.429.175.854.29 1.275.143-.391.278-.778.405-1.16h2.55c-.059.492-.175.955-.348 1.391-1.662-.038-3.325 0-4.983.116a7.22 7.22 0 0 1-.464-1.506c.86.034 1.71-.004 2.55-.116Z",
    opacity: 0.965
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.386 26.676h2.665v1.275a7.727 7.727 0 0 1-2.665 0v-1.275Z",
    opacity: 0.981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.078 26.676v1.39h-2.666v-1.274c.879-.112 1.768-.15 2.666-.116Z",
    opacity: 0.974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.04 26.56c.79.115 1.6.153 2.434.116-.08.475-.196.938-.348 1.39h-5.1a6.178 6.178 0 0 1-.347-1.274 16.13 16.13 0 0 1 2.666-.116c.104.384.2.77.29 1.159.104-.45.24-.874.405-1.275Z",
    opacity: 0.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.251 26.676h2.55a.535.535 0 0 0 .116.463v.927H61.25v-1.39Z",
    opacity: 0.999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.393 26.444c.415.146.859.223 1.333.232a4.228 4.228 0 0 0 1.333-.232v1.97c-.105-.082-.144-.198-.116-.348a14.81 14.81 0 0 0-2.55.116v-1.738Z",
    opacity: 0.952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.608 26.676h2.666v1.275c-.884.112-1.775.15-2.666.115v-1.39Z",
    opacity: 0.979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 26.444c.857.222 1.746.3 2.666.232v1.39h-2.55a.534.534 0 0 0-.116-.463v-1.159Z",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.108 26.56c.883.112 1.775.15 2.665.116v1.39a14.099 14.099 0 0 1-2.55-.115c0-.466-.039-.932-.115-1.391Z",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.511 27.487c3.022-.037 6.035.001 9.039.116v.695c-2.125-.038-4.25 0-6.373.116.091.305.169.615.231.927-.867.115-1.755.154-2.665.116a5.892 5.892 0 0 1-.232-1.97Z",
    opacity: 0.988
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.358 26.56 2.897.232c.087.394.203.781.348 1.159l-2.897.231a7.566 7.566 0 0 1-.348-1.622Z",
    opacity: 0.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.076 26.444 2.781.464a3.358 3.358 0 0 0-.116 1.159h-2.665v-1.623Z",
    opacity: 0.972
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.575 26.444a8.18 8.18 0 0 0 2.665.232v1.39a8.177 8.177 0 0 1-2.665-.231v-1.39Z",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.048 26.676h2.665v1.159c-.856.221-1.745.299-2.665.231v-1.39Z",
    opacity: 0.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.855 26.56v1.506h-2.549a.536.536 0 0 0-.116-.463v-.927c.898.034 1.787-.004 2.665-.116Z",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 27.603a.534.534 0 0 1 .116.464h2.55v1.506H78.75v-1.97Zm83.44 0a.536.536 0 0 1 .116.464h2.549v1.506h-2.665v-1.97Z",
    opacity: 0.962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.597 26.56a29.689 29.689 0 0 0 2.318 3.824 12.411 12.411 0 0 1-1.97 2.897 5.71 5.71 0 0 1-.985-1.274 15.43 15.43 0 0 1-1.217-2.202 33.907 33.907 0 0 0 1.854-3.245Z",
    opacity: 0.979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.874 27.834v1.623a13.26 13.26 0 0 1-3.477 0c.419-.112.611-.382.58-.811a.8.8 0 0 0 .116-.58 8.88 8.88 0 0 0 2.781-.232Z",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.713 27.834v1.739a16.123 16.123 0 0 0-2.665-.116v-1.39c.92.067 1.809-.01 2.665-.233Z",
    opacity: 0.945
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.386 27.95a7.722 7.722 0 0 0 2.665 0c.035.638.228 1.218.58 1.739a9.432 9.432 0 0 0-2.897 0 3.23 3.23 0 0 1-.348-1.739Z",
    opacity: 0.971
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.603 27.95a3.38 3.38 0 0 0 .927 1.391c-1.07.08-2.152.157-3.245.232a5.483 5.483 0 0 1-.579-1.39l2.897-.233Z",
    opacity: 0.974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.377 27.834a15.91 15.91 0 0 0 3.824.232c-.455.159-.919.333-1.39.522a1.238 1.238 0 0 0-.464.869h-2.665c.076-.62.308-1.16.695-1.623Z",
    opacity: 0.963
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.027 28.066h5.099l-.348 1.391a43.052 43.052 0 0 0-4.403.116 7.113 7.113 0 0 1-.348-1.507ZM58.122 28.067a4.596 4.596 0 0 1-.347 1.39H53.37a14.926 14.926 0 0 1-.232-1.275 53.618 53.618 0 0 1 4.983-.115Z",
    opacity: 0.984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.251 28.066h2.666v1.275a7.804 7.804 0 0 1-2.666.232v-1.507Z",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.059 28.414v1.39a9.6 9.6 0 0 0-2.897-.23l.231-1.392c.845-.111 1.698-.15 2.55-.115-.028.15.011.265.116.347Z",
    opacity: 0.974
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.274 27.95v3.245c-.097-.04-.136-.117-.116-.232v-1.39h-2.55v-1.507a16.12 16.12 0 0 0 2.666-.116Z",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.773 27.14h.116v3.94c-.078 0-.116-.039-.116-.116v-1.39H89.76c.19-.531.344-1.073.463-1.623a14.08 14.08 0 0 0 2.55.116v-.928Z",
    opacity: 0.988
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.07 28.066v1.507c-.89.035-1.782-.004-2.665-.116v-1.043c.104-.082.143-.198.116-.348h2.549Z",
    opacity: 0.968
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.076 28.066h2.665v1.275l-2.665.232v-1.507Z",
    opacity: 0.962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.257 28.066v1.391c-.878.112-1.767.15-2.665.116.06-.461.098-.925.116-1.39.84-.113 1.689-.151 2.549-.117Z",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.575 27.834c.856.222 1.745.3 2.665.232.115.374.231.76.348 1.16-.438.153-.92.23-1.448.23a11.407 11.407 0 0 1-1.565-.115v-1.507Z",
    opacity: 0.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.412 28.066h2.666a6.403 6.403 0 0 1-.232 1.507h-2.897c.241-.471.398-.981.463-1.507Z",
    opacity: 0.966
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.741 29.341v1.391a4.231 4.231 0 0 1-1.332.232 4.237 4.237 0 0 1-1.333-.232v-1.159l2.665-.232Z",
    opacity: 0.959
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.588 29.225c.515.978 1.326 1.345 2.434 1.101.398-.147.707-.399.927-.753h2.897c-.169.492-.402.96-.695 1.39h-8.46c.036.373-.002.72-.116 1.044V29.34c.512.074 1.034.113 1.565.116a4.373 4.373 0 0 0 1.448-.232Z",
    opacity: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.623 31.08a107.84 107.84 0 0 0-7.069-.116 2.88 2.88 0 0 1-.811-1.507c.91.038 1.798 0 2.666-.116.588 1.104 1.476 1.433 2.665.985.331-.257.563-.585.695-.985l.406-.116c.752.122 1.505.238 2.26.348a2.885 2.885 0 0 1-.812 1.507Z",
    opacity: 0.958
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.405 29.457c.883.112 1.775.151 2.665.116v1.622a8.174 8.174 0 0 0-2.665-.231v-1.507Z",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.53 29.341c1.588 1.041 3.21 1.08 4.867.116a13.26 13.26 0 0 0 3.477 0c.18.72-.052 1.223-.695 1.507h-9.735a3.912 3.912 0 0 1-1.159-1.39c1.093-.075 2.175-.153 3.245-.233Z",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.682 29.457h2.665c.304.977.961 1.344 1.97 1.101a2.345 2.345 0 0 0 1.275-.985c.898.035 1.787-.004 2.665-.116.018.466.056.93.116 1.39-2.773.115-5.554.154-8.344.117a3.773 3.773 0 0 1-.347-1.507Z",
    opacity: 0.962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.778 29.457a8.584 8.584 0 0 1-.463 1.507h-3.593a5.548 5.548 0 0 1-.347-1.391 43.08 43.08 0 0 1 4.403-.116Z",
    opacity: 0.978
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.37 29.457h4.405a7.112 7.112 0 0 1-.348 1.507 14.555 14.555 0 0 0-3.593.231 9.604 9.604 0 0 0-.463-1.738Z",
    opacity: 0.982
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.917 29.341c.512 1.17 1.362 1.459 2.55.87.212-.233.445-.446.695-.638a9.598 9.598 0 0 1 2.897.232v1.159a12.853 12.853 0 0 0-2.434.116h-.116a75.46 75.46 0 0 0-5.91-.116 3.087 3.087 0 0 1-.348-1.39 7.804 7.804 0 0 0 2.666-.233Z",
    opacity: 0.969
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.608 29.573h2.55v1.39h-2.55v-1.39Z",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 29.573h2.666v1.159a7.52 7.52 0 0 1-2.55.232.534.534 0 0 0-.116-.464v-.927Z",
    opacity: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.63 29.689c.548.64 1.244.852 2.087.637a3.397 3.397 0 0 0 1.043-.753h3.013v1.39c-2.801-.038-5.583 0-8.344.116a2.967 2.967 0 0 1-.695-1.39c.95-.15 1.916-.15 2.897 0Z",
    opacity: 0.973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.048 29.457c.898-.035 1.787.004 2.665.116v.811a.796.796 0 0 0-.115.58h-2.55v-1.507Z",
    opacity: 0.992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19 29.573h2.665v1.159a7.517 7.517 0 0 1-2.549.232.536.536 0 0 0-.116-.464v-.927Z",
    opacity: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.743 29.805c.345.765.752 1.502 1.217 2.202.276.482.605.907.985 1.274a29.55 29.55 0 0 1-2.202 2.202l-1.97-3.476a26.207 26.207 0 0 0 1.97-2.202Z",
    opacity: 0.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.773 30.964c0 .077.038.116.116.116v1.274h-2.55c.02-.387 0-.775-.058-1.159-1.392 1.444-2.995 1.734-4.809.87a4.222 4.222 0 0 1-1.043-.985 150.25 150.25 0 0 1 8.344-.116Z",
    opacity: 0.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.373 30.848c.087.483.243.952.464 1.39-.886.116-1.773.155-2.666.116a2.61 2.61 0 0 0-.289-.927c-1.733 1.408-3.529 1.505-5.389.29a4.205 4.205 0 0 1-.464-.753c2.79.037 5.571-.001 8.344-.116Z",
    opacity: 0.984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.076 30.732c.415.146.859.223 1.333.232a4.228 4.228 0 0 0 1.332-.232v1.622h-2.665v-1.622Z",
    opacity: 0.882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.722 30.964h3.593l-.232 1.39h-3.129l-.232-1.39Z",
    opacity: 0.909
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.427 30.964-.232 1.39c-1.006.039-2.013 0-3.013-.115a10.485 10.485 0 0 0-.348-1.043 14.554 14.554 0 0 1 3.593-.232Z",
    opacity: 0.914
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.599 30.964c1.99-.038 3.96 0 5.91.116-1.105 1.289-2.496 1.733-4.172 1.332-.816-.212-1.396-.695-1.738-1.448Z",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.059 30.964v1.39h-2.434V31.08c.79-.115 1.6-.154 2.434-.116Z",
    opacity: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.608 30.964h2.55c-.02.115.019.192.116.231v1.16h-2.666v-1.391Z",
    opacity: 0.929
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 30.5a.534.534 0 0 1 .116.464 7.517 7.517 0 0 0 2.55-.232v1.623H78.75V30.5Z",
    opacity: 0.891
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.554 30.964c2.357-.039 4.715 0 7.069.116-.898 1.066-2.057 1.568-3.476 1.506a5.308 5.308 0 0 1-3.245-1.1 1.287 1.287 0 0 1-.348-.522Z",
    opacity: 0.941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.405 30.964a8.18 8.18 0 0 1 2.665.232v1.158h-2.665v-1.39Z",
    opacity: 0.901
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.444 30.964h9.735c-2.476 1.658-5.141 2.025-7.997 1.1a5.051 5.051 0 0 1-1.738-1.1Z",
    opacity: 0.947
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.151 30.964c-1.185 1.5-2.691 1.945-4.52 1.332a8.342 8.342 0 0 1-1.333-.985 8.393 8.393 0 0 0-.058 1.39h-2.549a.535.535 0 0 0-.116-.463v-.231c.114-.323.152-.671.116-1.043h8.46Z",
    opacity: 0.936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.713 30.384v1.97h-2.665v-1.39h2.55a.795.795 0 0 1 .115-.58Z",
    opacity: 0.895
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19 30.5a.536.536 0 0 1 .116.464 7.514 7.514 0 0 0 2.549-.232v1.623h-2.665V30.5Z",
    opacity: 0.891
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.773 32.007 1.97 3.476a15.795 15.795 0 0 1-2.086 1.507.33.33 0 0 1-.29-.116 58.196 58.196 0 0 0-1.912-3.013 26.127 26.127 0 0 0 2.318-1.854Z",
    opacity: 0.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.575 32.238a.535.535 0 0 1 .116.464h2.549v1.159a7.514 7.514 0 0 1-2.549.232c.036.448-.002.873-.116 1.274v-3.129Z",
    opacity: 0.994
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.84 33.05a19.975 19.975 0 0 0 4.404 2.317 137.288 137.288 0 0 1 2.897 4.52 14.791 14.791 0 0 1-3.593-.696 475.404 475.404 0 0 1-3.824-6.084c.026-.046.065-.065.116-.058Z",
    opacity: 0.979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.455 33.86c.668.985 1.306 1.99 1.912 3.014a.331.331 0 0 0 .29.116 13.565 13.565 0 0 1-2.666 1.39 61.937 61.937 0 0 0-1.912-3.013.307.307 0 0 1 .058-.347l2.318-1.16Z",
    opacity: 0.978
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24 33.86v2.087h-2.665v-.58c.114-.4.152-.826.116-1.274a7.512 7.512 0 0 0 2.549-.232Z",
    opacity: 0.993
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.137 35.02a.307.307 0 0 0-.058.347c.666.986 1.304 1.991 1.912 3.014a14.395 14.395 0 0 1-3.36 1.158.261.261 0 0 1 .116-.173L22.66 36.12a.262.262 0 0 0 .116-.174 21.647 21.647 0 0 0 3.361-.927Z",
    opacity: 0.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.244 35.367c1.4.404 2.836.676 4.288.812a.262.262 0 0 1-.116.173 21.12 21.12 0 0 1 2.201 3.651c-1.18.038-2.338 0-3.476-.116a137.391 137.391 0 0 0-2.897-4.52Z",
    opacity: 0.985
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.776 35.947a.262.262 0 0 1-.116.174l2.087 3.244a.261.261 0 0 0-.116.174c-.988.25-1.997.404-3.014.464a21.12 21.12 0 0 0-2.201-3.65.262.262 0 0 0 .116-.174c1.089.01 2.17-.068 3.244-.232Z",
    opacity: 0.979
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "WunderGraph_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.584.775h173.833v40.56H.584z"
  })))));
};
export { SvgWunderGraph as ReactComponent };
export default __webpack_public_path__ + "static/WunderGraph.a8e2c990.svg";